import { CancellationAireFormVM } from 'cancellations/view-models/cancellation-aire';
import { DateTime } from 'luxon';
import { SubjectData } from 'shell/models/person';
import { AttachmentsData } from 'shell/models/practice';

interface RequestCancellationAireCitizenshipLost {
  datiSoggetto: SubjectData | undefined;
  dataDecorrenzaCancellazione: DateTime | undefined;
  iniziativaCancellazione: string;
  subEventoPerditaCittadinanza: string;
  dataPerditaCittadinanza: DateTime | undefined;
  nuovaCittadinanza: string;
  riferimentoOpeLegis: string | null;
  allegati: AttachmentsData[];
}

export const transformRequestCancellationAireCitizenshipLost = (
  values: CancellationAireFormVM
): RequestCancellationAireCitizenshipLost => {
  return {
    datiSoggetto: values.data,
    dataDecorrenzaCancellazione: values?.cancellationAire?.cancellationDate
      ? values.cancellationAire.cancellationDate
      : undefined,
    iniziativaCancellazione: values?.cancellationAire?.typeInitiative || '',
    subEventoPerditaCittadinanza: values?.cancellationAire?.subevent || '',
    dataPerditaCittadinanza: values?.cancellationAire?.lossCitizenshipDate
      ? values.cancellationAire.lossCitizenshipDate
      : undefined,
    nuovaCittadinanza: values?.cancellationAire?.newCitizenship?.id || '',
    riferimentoOpeLegis: values?.cancellationAire?.opeLegis?.value
      ? `Perdita cittadinanza italiana “OPE LEGIS ”${values.cancellationAire?.opeLegis?.value}`
      : null,
    allegati:
      values?.document?.files && values?.document?.files?.length > 0
        ? values?.document?.files?.map((file) => ({
            contenutoAllegato: file.raw?.split(',')[1] || '',
            nomeFile: file.name || '',
          }))
        : [],
  };
};
